// extracted by mini-css-extract-plugin
export default {"button":"v0u7IO","icon":"ra6ccf","facebook":"mQVVUY","twitter":"zYLQDU","link":"MBTwaD","share":"S5rM2V"};